import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { DataService } from 'src/app/services/data.service';
import { pushObjArray } from 'src/app/services/convert.service';

@Component({
  selector: 'app-add-word-class',
  templateUrl: './add-word-class.component.html',
  styleUrls: ['./add-word-class.component.scss']
})
export class AddWordClassComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Add new word class"
  form: FormGroup;
  name: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddWordClassComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public store: ActivityStore,
    private ds: DataService,
  ) { }

  ngOnInit() {
    const { ANSWER } = this.data;
    this.form = this.fb.group({
      name: [ANSWER ? ANSWER.name : null, Validators.compose([Validators.required])],
    })
    if (ANSWER) {
      this.TITLE = "Edit word class";
    }
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean, isDelete: boolean) {
    this.error = null;
    if (this.form.valid) {
      const { name } = f;
      const { GROUP, ANSWER } = this.data;
      const { words } = this.store;
      const answers = this.store.options
      const row = {
        key: ANSWER ? ANSWER.key : this.ds.createId(),
        name: `${name}`,
        group: GROUP
      };
      const options = pushObjArray(answers, row)
      const wordOptions = pushObjArray(words, row)
      this.store.options = options;
      this.store.words = wordOptions;
      this.form.reset();
      this.inputEl.nativeElement.focus();
      if (!isNew) {
        this.dialogRef.close('yes')
      }
      if (ANSWER) {
        this.dialogRef.close('yes')
      }
    }
  }
}